var _rect, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInlineNotif5({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 30,
    viewBox: "0 0 360 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 30,
    fill: "#FFFFFF"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 2,
    y: 19,
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif",
    fontSize: 13.5,
    fontWeight: 600,
    fill: "#464646"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#E29B2A"
  }, "#1 Bestseller "), "in brand X in last 2 days")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInlineNotif5);
export default __webpack_public_path__ + "static/media/inline_notif_5.5129464ce63e8f635b844c8822aeb3f9.svg";
export { ForwardRef as ReactComponent };